export var CustomPDFReportType;
(function (CustomPDFReportType) {
    CustomPDFReportType["AGGREGATE_SECURITY_COMPARISON"] = "aggregate_security_comparison";
    CustomPDFReportType["AGGREGATE_SECURITY_OVERVIEW"] = "aggregate_security_overview";
    CustomPDFReportType["MULTI_SECURITY_COMPARISON"] = "multi_security_comparison";
})(CustomPDFReportType || (CustomPDFReportType = {}));
